import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { UserAccountState } from '../user-account.state';
import type { UserSettingsState } from './user-settings.state';

const selectUserAccountState = createFeatureSelector('userAccount');

export const selectUserSettingsState = createSelector(
  selectUserAccountState,
  (userAccount: UserAccountState) => userAccount.userSettingsState
);

export const selectUserSettings = createSelector(selectUserSettingsState, (state: UserSettingsState) => state.userSettings);

export const selectUserLanguageCode = createSelector(selectUserSettings, settings => settings?.LanguageCode);
